import React, { FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  DatasetFCO,
  DatasetFCOFields,
  FCOFields,
  FeatureServiceFCO,
  WorkspaceFCOContainer,
} from '../../../core/types/fcoTypes';
import { useGetDatasets } from '../../../api/datasets';
import { Button, Empty, FlexGroup, FlexItem, Input, Link, Loading, Popover, Select, Table } from '@lithos';
import { ExtendedTableColumn } from '@lithos/Table';
import { TectonDateTimeFormat } from '../../@tecton/ComponentRedesign/utils';
import moment from 'moment';
import { useGetFcos } from '../../../api/fcos';
import DataSetsList from '../dataSets/DatasetsList';

interface FeatureServiceDatasetsProps {
  featureService: FeatureServiceFCO;
}

const FeatureServiceDatasets: FC<FeatureServiceDatasetsProps> = ({ featureService }) => {
  const { workspace } = useParams();

  const {
    data: fcoData,
    isError: fcoError,
    isLoading: fcoLoading,
  } = useGetFcos<WorkspaceFCOContainer>(workspace as string, {
    select: (data: WorkspaceFCOContainer) => {
      return {
        idToFcoMap: data.idToFcoMap,
      };
    },
  });
  // eslint-disable-next-line prefer-const
  let { data: datasetsData, isLoading: datasetsIsLoading, error: dataSetsError } = useGetDatasets(workspace as string);

  if (datasetsIsLoading || dataSetsError) {
    return <Loading />;
  }

  if (dataSetsError || fcoError) {
    return (
      <Empty
        useCase="errorUnknown"
        title="Error loading datasets"
        description="We ran into an error loading the datasets."
        placement={'full-page'}
        actions={undefined}
      />
    );
  }

  const matchingDatasets = datasetsData!.data.filter((dataset) => {
    return dataset.featureServiceId === featureService[FCOFields.ID];
  });

  return (
    <DataSetsList
      items={matchingDatasets ?? []}
      idToFcoMap={fcoData?.idToFcoMap ?? {}}
      workspace={workspace as string}
    />
  );
};

export default FeatureServiceDatasets;
